import app from '../app';

let provinceList = null;
let provinces = {};
let cities = {};
let counties = {};
let towns = {};

export function loadProvinceList() {
  return Promise.resolve()
    .then(() => {
      if (provinceList) {
        return provinceList;
      }

      return app.fetchAPI({ url: '/api/address/province' }).then(result => {
        let list = (result.data && result.data.listData) || [];
        list = list.map(item => {
          const itemId = item.id;

          provinces[itemId] = { ...provinces[itemId], ...item };

          return itemId;
        });

        provinceList = list;
        return list;
      });
    })
    .then(
      list => ({ list }),
      error => ({ error })
    );
}

export function loadCityList(provinceId) {
  return new Promise(resolve => {
    if (!provinceId) {
      throw new Error('loadCityList: provinceId is required');
    }

    resolve(provinceId);
  })
    .then(provinceId => {
      const province = provinces[provinceId];

      if (province && province.list) {
        return province.list;
      }

      return app
        .fetchAPI({ url: `/api/address/city/${provinceId}` })
        .then(result => {
          let list = (result.data && result.data.listData) || [];
          list = list.map(item => {
            const itemId = item.id;

            cities[itemId] = { ...cities[itemId], ...item };

            return itemId;
          });

          provinces[provinceId] = { ...provinces[provinceId], list };
          return list;
        });
    })
    .then(
      list => ({ list }),
      error => ({ error })
    );
}

export function loadCountyList(cityId) {
  return new Promise(resolve => {
    if (!cityId) {
      throw new Error('loadCountyList: cityId is required');
    }

    resolve(cityId);
  })
    .then(cityId => {
      const city = cities[cityId];

      if (city && city.list) {
        return city.list;
      }

      return app
        .fetchAPI({ url: `/api/address/county/${cityId}` })
        .then(result => {
          let list = (result.data && result.data.listData) || [];
          list = list.map(item => {
            const itemId = item.id;

            counties[itemId] = { ...counties[itemId], ...item };

            return itemId;
          });

          cities[cityId] = { ...cities[cityId], list };
          return list;
        });
    })
    .then(
      list => ({ list }),
      error => ({ error })
    );
}

export function loadTownList(countyId) {
  return new Promise(resolve => {
    if (!countyId) {
      throw new Error('loadTownList: countyId is required');
    }

    resolve(countyId);
  })
    .then(countyId => {
      const county = counties[countyId];

      if (county && county.list) {
        return county.list;
      }

      return app
        .fetchAPI({ url: `/api/address/town/${countyId}` })
        .then(result => {
          let list = (result.data && result.data.listData) || [];
          list = list.map(item => {
            const itemId = item.id;

            towns[itemId] = { ...towns[itemId], ...item };

            return itemId;
          });

          counties[countyId] = { ...counties[countyId], list };
          return list;
        });
    })
    .then(
      list => ({ list }),
      error => ({ error })
    );
}

export function getProvinceName(provinceId) {
  return provinces[provinceId] && provinces[provinceId].name;
}
export function getCityName(cityId) {
  return cities[cityId] && cities[cityId].name;
}
export function getCountyName(countyId) {
  return counties[countyId] && counties[countyId].name;
}
export function getTownName(townId) {
  return towns[townId] && towns[townId].name;
}

export function parseAddress(text = '') {
  let data = {
    name: '',
    mobile: '',
    detail: '',
    provinceId: '',
    provinceName: '',
    cityId: '',
    cityName: '',
    countyId: '',
    countyName: '',
    townId: '',
    townName: '',
  };
  let warnings = [];

  text = text.replace(/\s/g, '');
  let groups = [];

  [',', ';', '，', '；', '、'].some(sep => {
    let arr = text.split(sep);
    const phoneIdx = arr.findIndex(str => /^1\d{10}$/.test(str));

    if (phoneIdx === -1) {
      return false;
    }

    groups[0] = arr[phoneIdx];
    arr.splice(phoneIdx, 1);

    const nameIdx = arr.findIndex(
      (str, idx) => (idx === 0 || idx === arr.length - 1) && str.length <= 4
    );

    if (nameIdx !== -1) {
      groups[1] = arr[nameIdx];
      arr.splice(nameIdx, 1);
    }

    groups[2] = arr.join(sep);

    return true;
  });

  if (groups.length === 0) {
    const matches = text.match(/^(.*)(1\d{10})(.*)$/);

    if (matches) {
      groups[0] = matches[2];

      if (matches[1].length < matches[3].length) {
        groups[1] = matches[1];
        groups[2] = matches[3];
      } else {
        groups[1] = matches[3];
        groups[2] = matches[1];
      }
    }
  }

  if (groups.length === 0) {
    warnings.push('手机号');
  } else {
    data.mobile = groups[0];

    if (groups[1]) {
      data.name = groups[1];
    } else {
      warnings.push('收件人');
    }

    text = groups[2];
  }

  return loadProvinceList()
    .then(result => {
      if (result.error) {
        throw result.error;
      }
      if (result.list.length === 0) {
        return;
      }

      const provinceId = result.list.find(itemId => {
        const provinceName = getProvinceName(itemId);
        let idx = text.indexOf(provinceName);

        if (idx === -1) {
          return false;
        }

        data.provinceId = itemId;
        data.provinceName = provinceName;

        text = text.slice(idx + provinceName.length);

        let firstText = text.charAt(0);
        if (firstText === '省' || firstText === '市') {
          text = text.slice(1);
        }

        return true;
      });

      if (!provinceId) {
        warnings.push('省份');
      }

      return provinceId;
    })
    .then(provinceId => {
      return (
        provinceId &&
        loadCityList(provinceId).then(result => {
          if (result.error) {
            throw result.error;
          }
          if (result.list.length === 0) {
            return;
          }

          const cityId = result.list.find(itemId => {
            const cityName = getCityName(itemId);
            let idx = text.indexOf(cityName);

            if (idx === -1) {
              return false;
            }

            data.cityId = itemId;
            data.cityName = cityName;

            text = text.slice(idx + cityName.length);
            return true;
          });

          if (!cityId) {
            warnings.push('城市');
          }

          return cityId;
        })
      );
    })
    .then(cityId => {
      return (
        cityId &&
        loadCountyList(cityId).then(result => {
          if (result.error) {
            throw result.error;
          }
          if (result.list.length === 0) {
            return;
          }

          const countyId = result.list.find(itemId => {
            const countyName = getCountyName(itemId);
            let idx = text.indexOf(countyName);

            if (idx === -1) {
              return false;
            }

            data.countyId = itemId;
            data.countyName = countyName;

            text = text.slice(idx + countyName.length);
            return true;
          });

          if (!countyId) {
            warnings.push('地区');
          }

          return countyId;
        })
      );
    })
    .then(countyId => {
      return (
        countyId &&
        loadTownList(countyId).then(result => {
          if (result.error) {
            throw result.error;
          }
          if (result.list.length === 0) {
            return;
          }

          const townId = result.list.find(itemId => {
            const townName = getTownName(itemId);
            let idx = text.indexOf(townName);

            if (idx === -1) {
              return false;
            }

            data.townId = itemId;
            data.townName = townName;

            text = text.slice(idx + townName.length);
            return true;
          });

          if (!townId) {
            warnings.push('街道');
          }

          return townId;
        })
      );
    })
    .then(() => {
      data.detail = text;
      let message = '';

      if (warnings.length > 0) {
        message = `未找到 ${warnings.join('、')} 哦，请您手动选择`;
      }

      return { data, message };
    })
    .catch(error => ({ error }));
}
